'use strict';

$(() => {
    // SEO Btn — navigate to data-url on click (avoids double anchor nesting)
    $(document).on('click', '.js-seo-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const url = $(this).data('url');
        if (url) {
            window.location.href = url;
        }
    });

    // Tooltip
    $('[data-toggle="tooltip"]').tooltip();

    // Focus mode detection: add/remove 'using-mouse' so CSS can suppress
    // the focus ring for pointer users while keeping it for keyboard users.
    document.body.classList.add('using-mouse');
    window.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
            document.body.classList.remove('using-mouse');
        }
    });
    window.addEventListener('mousedown', function () {
        document.body.classList.add('using-mouse');
    });
});

module.exports = {};
